import {onBeforeUnmount, ref} from "vue";
import formatHelper from "@/core/helpers/formatHelper";

/**
 * Composable to handle postal code input and formatting.
 */
const usePostalCode = () => {
    const postalCode = ref<string | undefined>(undefined);
    const timer = ref<ReturnType<typeof setTimeout> | null>(null);

    /**
     * Format a zip code to match the 5 characters french format
     */
    const formatZipcode = () => {
        if (postalCode.value) {
            postalCode.value = formatHelper.formatZipCode(postalCode.value);
        }
    };

    /**
     * Debounce the zip code formatting to avoid formatting on every keystroke.
     */
    const debounceFormatZipcode = (timeout: number) => {
        if (timer.value) {
            clearTimeout(timer.value);
        }

        timer.value = setTimeout(formatZipcode, timeout);
    };

    onBeforeUnmount(() => {
        if (timer.value) {
            clearTimeout(timer.value);
        }
    });

    return {
        postalCode,
        debounceFormatZipcode,
        formatZipcode
    };
};

export default usePostalCode;
